import { render } from "./StationDetailsSkeleton.vue?vue&type=template&id=c65451d6"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__